import 'es6-promise';
import 'isomorphic-fetch';
import * as _ from 'lodash';
import * as actions from './index';
import { ISearchCriteria } from '../state-helpers/search-criteria'
import { IState } from '../reducers'

export const trackFetch = (searchTerm: string, trackingId: string, hitId: string) => {
    var url = '/api/v1/search/trackClick'
    const init: RequestInit = {
        method: 'POST',
        body: JSON.stringify({
                SearchTerm: searchTerm,
                TrackingId: trackingId,
                HitId: hitId
        }),
        headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
    };
    return window.fetch(url, init)
        .then(function (response) {
            if (response.status === 504) {
                const errorMsg = new Error("Failed to fetch");
                errorMsg.message = "Failed to fetch";
                throw errorMsg;
            }
            // Catch the bad response
            else if (response.status >= 400) {
                const errorMsg = new Error("Bad response");
                errorMsg.message = "Bad response";
                throw errorMsg;
            }
            return response.json();
        })
        .then(m => console.log(m));
};

export function trackClick(hitId: string) {
    return (dispatch, getState) => {
        let state = getState() as IState;
        var searchTerm = state.searchTermModel;
        var trackingId = state.resultsModel.trackingId;
        trackFetch(searchTerm, trackingId, hitId);
    }
}